import { render, staticRenderFns } from "./TripartiteDataForm.vue?vue&type=template&id=65e98802&scoped=true"
import script from "./TripartiteDataForm.vue?vue&type=script&lang=js"
export * from "./TripartiteDataForm.vue?vue&type=script&lang=js"
import style0 from "./TripartiteDataForm.vue?vue&type=style&index=0&id=65e98802&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e98802",
  null
  
)

export default component.exports